import {
    DomainAction
} from '../index'

const domain = "Workflow"

export const Workflow = {
    getAll: new DomainAction(domain, 'GetAll', DomainAction.methods.get),
    getSingle: new DomainAction(domain, '', DomainAction.methods.get),
    create: new DomainAction(domain, '', DomainAction.methods.post),
    update: new DomainAction(domain, '', DomainAction.methods.put),
    delete: new DomainAction(domain, '', DomainAction.methods.delete),
    getBySystemCode: new DomainAction(domain, 'Code?systemCode=', DomainAction.methods.get),
    GetAllWorkflowSteps: new DomainAction(domain, 'GetAllWorkflowSteps', DomainAction.methods.get),
    updateWorkflowStep: new DomainAction(domain, 'UpdateWorkflowStep', DomainAction.methods.put),
    createWorkflowStep: new DomainAction(domain, 'CreateWorkflowStep', DomainAction.methods.post),
    deleteStep: new DomainAction(domain, 'DeleteWorkflowStep', DomainAction.methods.delete)
    
}